import React from "react";
export default function MIN() {
  return <div>Excel_MIN</div>;
}
